<template>
    <Breadcrumbs :list="breadcrumpsList"/>
    <div class="main-card mb-3 card">
        <div class="card-body">



            <pv-table
                    ref="dt"
                    :value="events"
                    :lazy="true"
                    :totalRecords="totalRecords"
                    :paginator="true"
                    :rows="20"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    :rowsPerPageOptions="[20, 50, 100]"
                    currentPageReportTemplate="{first} - {last} z {totalRecords}"
                    responsiveLayout="scroll"
                    v-model:filters="filters"
                    v-model:selection="selectedRows"
                    filterDisplay="row"
                    :loading="loading"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                    @filter="onFilter($event)"

            >
                <pv-column field="planTerm.planShop.action.name" header="Akcja" style="width: 120px" >
                    <template #filter="{filterModel, filterCallback}">
                        <pv-input-text
                                type="text"
                                v-model="filterModel.value"
                                class="p-column-filter"
                                @input="filterCallback()"
                                :placeholder="'Szukaj...'"/>
                    </template>
                </pv-column>

                <pv-column field="planTerm.planShop.shop.shortName" header="Nazwa sklepu" style="width: 100px" >
                    <template #filter="{filterModel, filterCallback}">
                        <pv-input-text
                                type="text"
                                v-model="filterModel.value"
                                class="p-column-filter"
                                @input="filterCallback()"
                                :placeholder="'Szukaj...'"/>
                    </template>
                    <template #body="{data}">
                        <span>{{data.planTerm.planShop.shop.shortName}}</span>
                        <span style="display: block;clear: both; font-size: 0.9em; color: #888;">{{data.planTerm.locationDescription}}</span>
                    </template>
                </pv-column>
                <pv-column field="planTerm.planShop.shop.city" header="Miasto" style="width: 100px" >
                    <template #filter="{filterModel, filterCallback}">
                        <pv-input-text
                                type="text"
                                v-model="filterModel.value"
                                class="p-column-filter"
                                @input="filterCallback()"
                                :placeholder="'Szukaj...'"/>
                    </template>
                </pv-column>
                <pv-column field="planTerm.planShop.shop.street" header="Ulica" style="width: 200px" >
                    <template #filter="{filterModel, filterCallback}">
                        <pv-input-text
                                type="text"
                                v-model="filterModel.value"
                                class="p-column-filter"
                                @input="filterCallback()"
                                :placeholder="'Szukaj...'"/>
                    </template>
                </pv-column>
                <pv-column field="planTerm.planShop.shop.postcode" header="Kod pocztowy" style="width: 60px" >
                    <template #filter="{filterModel, filterCallback}">
                        <pv-input-text
                                type="text"
                                v-model="filterModel.value"
                                class="p-column-filter"
                                @input="filterCallback()"
                                :placeholder="'Szukaj...'"/>
                    </template>
                </pv-column>
                <pv-column field="planTerm.planShop.planSv.user.lastName" header="Supervisor" style="width: 120px" >
                    <template #filter="{filterModel, filterCallback}">
                        <pv-input-text
                                type="text"
                                v-model="filterModel.value"
                                class="p-column-filter"
                                @input="filterCallback()"
                                :placeholder="'Szukaj...'"/>
                    </template>
                    <template #body="{data}">
                        <span v-if="data.planTerm.planShop.planSv">{{data.planTerm.planShop.planSv.user.firstName}} {{data.planTerm.planShop.planSv.user.lastName}}</span>
                    </template>
                </pv-column>

                <pv-column field="planBa.user.lastName" header="Hostessa" style="width: 120px" >
                    <template #filter="{filterModel, filterCallback}">
                        <pv-input-text
                                type="text"
                                v-model="filterModel.value"
                                class="p-column-filter"
                                @input="filterCallback()"
                                :placeholder="'Szukaj...'"/>
                    </template>
                    <template #body="{data}">
                        <span v-if="data.planBa.user">{{data.planBa.user.firstName}} {{data.planBa.user.lastName}}</span>
                    </template>
                </pv-column>


                <pv-column header="Temin" style="width: 140px" field="planTerm.dateFrom">
                    <template #filter="{filterModel, filterCallback}">
                        <pv-calendar
                                type="text"
                                dateFormat="dd.mm.yy"
                                v-model="filterModel.value"
                                class="p-column-filter"
                                @date-select="filterCallback()"
                                :placeholder="'Szukaj...'"/>
                    </template>

                    <template #body="{data}">
                        {{convertDateToString(data.planTerm.dateFrom)}}<br/>{{convertDateToString(data.planTerm.dateTo)}}
                    </template>
                </pv-column>
                <pv-column header="Status" style="width: 80px" >
                    <template #body="{data}">
                        <span v-if="data.status == 'PLANNED'">Planowany</span>
                        <span v-if="data.status == 'WORKING'">W trakcie</span>
                        <span v-if="data.status == 'CLOSED'">Zamknięty</span>
                    </template>
                </pv-column>


            </pv-table>
        </div>
    </div>
</template>

<script>

    import Breadcrumbs from '@miro-labs/vue3-architect-layout/layout/base/Breadcrumbs.vue'
    import DateTable from 'primevue/datatable'
    import Column from 'primevue/column'
    import InputText from 'primevue/inputtext'
    import Calendar from 'primevue/calendar';
    import {FilterMatchMode} from 'primevue/api';


    export default {
        setup() {
            const breadcrumpsList = [
                {label: "Strona główna", routerName: 'mainPage', params: {}, query: {}},
                {label: "Serwis", routerName: 'serviceList', params: {}, query: {}},
                {label: "Akcje", routerName: 'serviceList', params: {}, query: {}},
                {label: "Plan"}
            ];
            return {
                breadcrumpsList
            }
        },


        components: {
            Breadcrumbs,
            'pv-table': DateTable,
            'pv-column': Column,
            'pv-input-text': InputText,
            'pv-calendar': Calendar
        },




        data() {
            var d = new Date();
            d.setHours(0,0,0,0);

            return {
                visibleEditDialog: false,
                visibleDialog: false,
                dataTerm: null,
                loading: false,
                events: [],
                totalRecords: 0,
                enableAction: true,
                importing: false,
                filters: {
                    'planTerm.planShop.action.name': {value: '', matchMode: FilterMatchMode.CONTAINS},
                    'planTerm.planShop.shop.shortName': {value: '', matchMode: FilterMatchMode.CONTAINS},
                    'planTerm.planShop.shop.city': {value: '', matchMode: FilterMatchMode.CONTAINS},
                    'planTerm.planShop.shop.postcode': {value: '', matchMode: FilterMatchMode.CONTAINS},
                    'planTerm.planShop.planSv.user.lastName': {value: '', matchMode: FilterMatchMode.CONTAINS},
                    'planTerm.planShop.shop.street': {value: '', matchMode: FilterMatchMode.CONTAINS},
                    'planBa.user.lastName': {value: '', matchMode: FilterMatchMode.CONTAINS},
                    'planTerm.dateFrom': {value: d, matchMode: FilterMatchMode.CONTAINS},
                },
                lazyParams: {},
                selectedRows: [],
            }
        },


        methods: {
            convertDateToString(dateStr) {
                let date = new Date(dateStr);

                return date.toLocaleDateString('pl-Pl', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }) + " " + date.toLocaleTimeString('pl-Pl', {hour: '2-digit', minute:'2-digit'});
            },







            async refreshTable() {
                this.loading = true;
                let query = {
                    filter: {
                        startDate: this.lazyParams.filters['planTerm.dateFrom'].value,
                        actionName: this.lazyParams.filters['planTerm.planShop.action.name'].value,
                        shopShortName: this.lazyParams.filters['planTerm.planShop.shop.shortName'].value,
                        shopCity: this.lazyParams.filters['planTerm.planShop.shop.city'].value,
                        shopPostcode: this.lazyParams.filters['planTerm.planShop.shop.postcode'].value,
                        shopStreet: this.lazyParams.filters['planTerm.planShop.shop.street'].value,
                        svName: this.lazyParams.filters['planTerm.planShop.planSv.user.lastName'].value,
                        baName: this.lazyParams.filters['planBa.user.lastName'].value,
                    },
                    pageNo: this.lazyParams.page,
                    pageSize: this.lazyParams.rows,
                    sortDirection: 'ASC',
                    sortName: 'planTerm.dateFrom'
                };
                let response = await this.$store.dispatch('sv/findBaTermsByQuery', query);
                this.totalRecords = response.totalElements;
                this.events = response.content;

                this.loading = false;
            },


            onPage(event) {
                this.lazyParams = event;
                this.refreshTable();
            },
            onSort(event) {
                this.lazyParams = event;
                this.refreshTable();
            },
            onFilter() {
                console.log('filter');
                this.lazyParams.filters = this.filters;
                this.refreshTable();
            },



        },


        watch: {
            filter: {
                handler() {
                    this.refreshTable();
                },
                deep: true
            }
        },


        mounted() {
            this.loading = true;
            this.lazyParams = {
                first: 0,
                rows: this.$refs.dt.rows,
                sortField: null,
                sortOrder: null,
                filters: this.filters
            };

            this.refreshTable();
        },

    }
</script>